import type { IntlShape } from 'react-intl'
import type { SupplierFormInput, SupplierHeader } from './types'

export const supplierHeaders: SupplierHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Numero',
				description: 'Table column header: Uuid',
			}),
		key: 'uuid', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Yritys',
				description: 'Table column header: Company',
			}),
		key: 'company', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Etunimi',
				description: 'Table column header: First name',
			}),
		key: 'firstName', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sukunimi',
				description: 'Table column header: Last name',
			}),
		key: 'lastName', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sähköposti',
				description: 'Table column header: Email',
			}),
		key: 'email', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ryhmä',
				description: 'Table column header: Group',
			}),
		key: 'group', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
]

export const supplierFormHeaders: SupplierFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Numero',
				description: 'Number',
			}),
		key: 'number',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Yritys',
				description: 'Company',
			}),
		key: 'company',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Y-tunnus',
				description: 'Business ID',
			}),
		key: 'businessId',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Etunimi',
				description: 'First name',
			}),
		key: 'firstName',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sukunimi',
				description: 'Last name',
			}),
		key: 'lastName',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lähiosoite',
				description: 'Street address',
			}),
		key: 'street',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Postinumero',
				description: 'Postal code',
			}),
		key: 'postalCode',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Postitoimipaikka',
				description: 'City',
			}),
		key: 'city',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maa',
				description: 'Country',
			}),
		key: 'country',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Puhelin 1',
				description: 'Phone 1',
			}),
		key: 'phone1',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Puhelin 2',
				description: 'Phone 2',
			}),
		key: 'phone2',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Faksinumero',
				description: 'Fax number',
			}),
		key: 'fax',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sähköposti',
				description: 'Email',
			}),
		key: 'email',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Internetsosoite',
				description: 'Internet address',
			}),
		key: 'internetAddress',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Verkkosivusto',
				description: 'Website',
			}),
		key: 'website',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ryhmä',
				description: 'Group',
			}),
		key: 'group',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Avainsana',
				description: 'Keyword',
			}),
		key: 'keyword',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimittaja',
				description: 'Is supplier',
			}),
		key: 'isSupplier',
		show: true,
		type: 'boolean',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Asiakas',
				description: 'Is customer',
			}),
		key: 'isCustomer',
		show: true,
		type: 'boolean',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Osasto',
				description: 'Department',
			}),
		key: 'department',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kuvaus',
				description: 'Description',
			}),
		key: 'description',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV-numero',
				description: 'VAT number',
			}),
		key: 'vatNumber',
		show: true,
		type: 'string',
	},
]

export const additionalInformationFormHeaders: SupplierFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimitusosoite',
				description: 'Delivery address',
			}),
		key: 'deliveryAddress',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimituspostinumero',
				description: 'Delivery postal code',
			}),
		key: 'deliveryPostalCode',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimituskaupunki',
				description: 'Delivery city',
			}),
		key: 'deliveryCity',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimitusmaa',
				description: 'Delivery country',
			}),
		key: 'deliveryCountry',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kieli',
				description: 'Language',
			}),
		key: 'language',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Currency',
			}),
		key: 'currency',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Myyjä',
				description: 'Salesperson',
			}),
		key: 'salesperson',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksuehto',
				description: 'Payment term',
			}),
		key: 'paymentTerm',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimitustapa',
				description: 'Delivery method',
			}),
		key: 'deliveryMethod',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskutustapa',
				description: 'Invoicing method',
			}),
		key: 'invoicingMethod',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Aleprosentti',
				description: 'Discount percentage',
			}),
		key: 'discountPercentage',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Alennustaulukko',
				description: 'Discount table',
			}),
		key: 'discountTable',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Verkkolaskuosoite',
				description: 'E-invoice address',
			}),
		key: 'eInvoiceAddress',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Verkkolaskun välittäjä',
				description: 'E-invoice operator',
			}),
		key: 'eInvoiceOperator',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Oston selite',
				description: 'Purchase description',
			}),
		key: 'purchaseDescription',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tilinumero',
				description: 'Account number',
			}),
		key: 'iban',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'BIC',
				description: 'BIC code',
			}),
		key: 'bic',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ostotili',
				description: 'Purchase account',
			}),
		key: 'purchaseAccount',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV-koodi',
				description: 'VAT code',
			}),
		key: 'vatCode',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Myyntisaamiset tili',
				description: 'Accounts receivable account',
			}),
		key: 'accountsReceivableAccount',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ostovelka tili',
				description: 'Accounts payable account',
			}),
		key: 'accountsPayableAccount',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Vakioviite',
				description: 'Default reference',
			}),
		key: 'defaultReference',
		show: true,
		type: 'string',
	},
]
